import React from 'react';
import PropTypes from 'prop-types';
import { useObserver } from 'mobx-react';
import { Link } from 'core/routing';
import { imageSrc } from 'apps/file/utils';
import { conf as mainConf } from 'apps/config.yaml';

import { Wrapper, AvatarStyled } from './commenters.styled';

export default function Commenters(props) {
  const { commenters } = props;

  return useObserver(() => (
    <Wrapper className={props.className}>
      {commenters.apps &&
        commenters.apps.length > 0 &&
        commenters.apps.map(commenter => (
          <Link
            name='profile'
            params={{ profile: `${commenter.username}` }}
            key={`block-${commenter.username}`}
            content={commenter.content}
          >
            <AvatarStyled
              src={imageSrc(
                commenter.avatar,
                commenter.imageFallbackPath,
                mainConf.imgSizes.profile.small,
              )}
              size='44px'
            />
          </Link>
        ))}
    </Wrapper>
  ));
}

Commenters.propTypes = {
  className: PropTypes.string,
  commenters: PropTypes.object,
};
